import styled, { css } from 'styled-components';
import { colors, boxShadow } from 'styles/theme';

// prettier-ignore
export default styled.div`
  position: absolute;
  top: calc(100% + 10px);
  left: -9999px;
  z-index: 1000;
  opacity: 0;
  transform: translateX(-50%);
  transition: opacity 0.3s, transform 0.3s, left 0s 0.3s;
  transform-origin: top center;
  border-radius: 4px;
  box-shadow: ${boxShadow.big};
  background-color: ${colors.white};
  padding: 20px;
  width: 230px;
  text-align: left;

  ${props => props.isOpen && `
    left: 50%;
    opacity: 1;
    transition: opacity 0.3s, transform 0.3s, left 0s;
    transform: translateX(-50%);
  `};

  ${props => props.theme.vertical && css`
    border-radius: 0;
    position: static;
    box-shadow: none;
    transform: none;
    border-left: 1px solid ${colors.border};
    padding: 0 20px;
    opacity: 1;
  `}
`;



// WEBPACK FOOTER //
// ./src/components/shared/MainNav/components/SubNav.js